// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__WPZnV","list":"styles_list__avRTx","actions":"styles_actions__mUGRV"};